import { render } from "./Admin.vue?vue&type=template&id=a1817000&scoped=true&bindings={\"submit\":\"options\"}"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"

import "./Admin.vue?vue&type=style&index=0&id=a1817000&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a1817000"

export default script